import { render, staticRenderFns } from "./liveRoomManager.vue?vue&type=template&id=1b1dde37&scoped=true"
import script from "./liveRoomManager.vue?vue&type=script&lang=js"
export * from "./liveRoomManager.vue?vue&type=script&lang=js"
import style0 from "./liveRoomManager.vue?vue&type=style&index=0&id=1b1dde37&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1dde37",
  null
  
)

export default component.exports